import { render, staticRenderFns } from "./SearchEmptyResults.vue?vue&type=template&id=6d67c2bb&scoped=true"
import script from "./SearchEmptyResults.vue?vue&type=script&lang=js"
export * from "./SearchEmptyResults.vue?vue&type=script&lang=js"
import style0 from "./SearchEmptyResults.vue?vue&type=style&index=0&id=6d67c2bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d67c2bb",
  null
  
)

export default component.exports